import { ContextBusiness, defaultPricingPlan } from 'models';

export const vpkClassroomQuestion = {
    requiredQualification: '45 Hours Completed',
    prompt: 'Will the substitute be working in a VPK classroom?',
    businessFlag: 'has_vpk_location',
} as const;

export const vpkClassroomHelperText = `If yes, we'll automatically add ${vpkClassroomQuestion.requiredQualification} to the required credentials.`;

export function vpkFeePercent(businesses?: ContextBusiness[]) {
    const plan = (businesses ?? []).map((business) => business.pricing_plan).find((p) => p?.hourly_type === 'PERCENT');
    return plan ? plan.hourly_value : defaultPricingPlan.hourly_value;
}

export function uncoveredVpkFeeNotice(feePercent: number) {
    return `As per ELC policy, because your center is only VPK-contracted, the Tandem fee can only be covered for substitutes in VPK classrooms. For this shift, you'll pay ${feePercent}% on top of the worker's rate.`;
}

export const uncoveredVpkFeeConfirmLabel = 'I confirm';
